/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface DemandeFormationSearch
 */
export interface DemandeFormationSearch {
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DemandeFormationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DemandeFormationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DemandeFormationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DemandeFormationSearch interface.
 */
export function instanceOfDemandeFormationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeFormationSearchFromJSON(json: any): DemandeFormationSearch {
    return DemandeFormationSearchFromJSONTyped(json, false);
}

export function DemandeFormationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeFormationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DemandeFormationSearchToJSON(value?: DemandeFormationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

